import type { VoucherListParams } from '@/marketing/models/voucher';

export const VOUCHER_KEYS = {
  all: ['affiliate-vouchers'] as const,
  lists: () => [...VOUCHER_KEYS.all, 'list'] as const,
  list: (params: VoucherListParams) => [...VOUCHER_KEYS.lists(), params] as const,
  performance: (code: string) => [...VOUCHER_KEYS.all, 'performance', code] as const,
  tierRates: () => [...VOUCHER_KEYS.all, 'tier-rates'] as const,
} as const;
